import React from "react";
import "./sidebar.css";
import {
  LineStyle,
  PersonAdd,
  Description,
  SupervisedUserCircle,
  History,
  Subscriptions,
} from "@material-ui/icons";
import { NavLink } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Sidebar() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Drawer className="mobile-sidebar" variant="permanent" open={open}>
        <DrawerHeader className="drawerHeader">
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
          <IconButton
            className="rm-margin"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
        </DrawerHeader>

        <Divider />
        <List>
          <NavLink to="/" className="link">
            <li className="sidebarListItem">
              <LineStyle className="sidebarIcon" />
              Home
            </li>
          </NavLink>
          <NavLink to="/newuser" className="link">
            <li className="sidebarListItem">
              <PersonAdd className="sidebarIcon" />
              Add Users
            </li>
          </NavLink>
          <NavLink to="/gamerules" className="link">
            <li className="sidebarListItem">
              <Description className="sidebarIcon" />
              Game Rules
            </li>
          </NavLink>

          <NavLink to="/userlist" className="link">
            <li className="sidebarListItem">
              <SupervisedUserCircle className="sidebarIcon" />
              All Users
            </li>
          </NavLink>
          {/* <NavLink to="/userlist" className="link">
            <li className="sidebarListItem">
              <SupervisedUserCircle className="sidebarIcon" />
              Game codes File
            </li>
          </NavLink> */}
          {/* <NavLink to="/userdashboard" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  User Dashboard
                </li>
              </NavLink> */}
              {/* <NavLink to="/selectteam" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  select Team
                </li>
              </NavLink> */}
          {/* <li className="sidebarListItem">
            <History className="sidebarIcon" />
            Game Log
          </li> */}
          {/* <NavLink to="/allSubscriptions" className="link">
            <li className="sidebarListItem">
              <Subscriptions className="sidebarIcon" />
              All Subscriptions
            </li>
          </NavLink>

          <NavLink to="/subscriptionBundles" className="link">
            <li className="sidebarListItem">
              <Subscriptions className="sidebarIcon" />
              Subscription Bundles
            </li>
          </NavLink> */}
        </List>
        <Divider />
      </Drawer>

      <div className="sidebar">
        <div className="sidebarWrapper">
          <div className="sidebarMenu">
            {/* <h3 className="sidebarTitle">Dashboard</h3> */}
            <ul className="sidebarList">
              <NavLink to="/" className="link">
                <li className="sidebarListItem">
                  <LineStyle className="sidebarIcon" />
                  Home
                </li>
              </NavLink>
              <NavLink to="/newuser" className="link">
                <li className="sidebarListItem">
                  <PersonAdd className="sidebarIcon" />
                  Add Users
                </li>
              </NavLink>

              <NavLink to="/gamerules" className="link">
                <li className="sidebarListItem">
                  <Description className="sidebarIcon" />
                  Game Rules
                </li>
              </NavLink>

              <NavLink to="/userlist" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  All Users
                </li>
              </NavLink>
              {/* <NavLink to="/gamecodes" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  Game Codes Files
                </li>
              </NavLink> */}
              {/* <NavLink to="/userdashboard" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  User Dashboard
                </li>
              </NavLink> */}
              {/* <NavLink to="/selectteam" className="link">
                <li className="sidebarListItem">
                  <SupervisedUserCircle className="sidebarIcon" />
                  select team
                </li>
              </NavLink> */}
              {/* <li className="sidebarListItem">
                <History className="sidebarIcon" />
                Game Log
              </li> */}
              {/* <NavLink to="/allSubscriptions" className="link">
                <li className="sidebarListItem">
                  <Subscriptions className="sidebarIcon" />
                  All Subscriptions
                </li>
              </NavLink>
              <NavLink to="/subscriptionBundles" className="link">
            <li className="sidebarListItem">
              <Subscriptions className="sidebarIcon" />
              Subscription Bundles
            </li>
          </NavLink> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
